import { DocumentScanner, documentScannerType } from './DocumentScanner'

class CustomFormFields {
  static $inject = ['formFields']
  constructor(formFields) {
    formFields.register(documentScannerType, DocumentScanner)
  }
  documentScannerType
}

export default {
  __init__: ['documentScannerField'],
  documentScannerField: ['type', CustomFormFields],
}
